import React, { useState, useMemo } from 'react';
import { styles } from '../canCare.styles';
import { makeStyles } from '@material-ui/core/styles';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import SmallCalendar from 'react-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import RightIcon from '../../../images/chevron_right.svg';
import { Dialog, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import EventDetails from './EventDetails';
import modalStyle from '../../../EditDevice/editDevice.styles.js';
import '../cancare.css';
import AddIcon from '@mui/icons-material/Add';
import useStore from '../../../Store/Store';
import Button from '../../../components/Button.jsx';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const CalenderViewButton = [Views.DAY, Views.WEEK, Views.MONTH];
const EVENT_STATUS = { pending: 'PENDING', completed: 'COMPLETED', cancelled: 'CANCELLED' };

const useStyles = makeStyles(modalStyle);

const COLORS = {
  PRIMARY: '#4152AF',
  DANGER: '#E15140',
  SECONDARY: '#FFC007',
  WHITE: '#fff',
  SUCCESS: '#5CB85B',
  GREY: '#979797',
  PURPLE: '#BF76F6',
  BLUE: '#00C6F7',
};

const EVENT_TYPE = {
  social_visit: 'social_visit',
  medication_reminder: 'medication_reminder',
  appointment: 'appointment',
  task: 'task',
};

const EVENT_COLORS = {
  [EVENT_TYPE.appointment]: COLORS.SECONDARY,
  [EVENT_TYPE.medication_reminder]: COLORS.BLUE,
  [EVENT_TYPE.social_visit]: COLORS.PURPLE,
  [EVENT_TYPE.task]: COLORS.SUCCESS,
};

const localizer = momentLocalizer(moment);
function Index({ events, handleAddEvent, showTodaysEvent, isDay = true }) {
  const [defaultDate, setDefaultDate] = useState(new Date());
  const width = useStore((state) => state.screenWidth);

  const [calenderView, setCalenderView] = useState(isDay ? Views.DAY : Views.MONTH);
  const [myEvents, setEvents] = useState();
  const [eventDetails, setEventDetails] = useState({
    event: null,
    showModal: false,
  });
  const classes = useStyles();

  React.useEffect(() => {
    setEvents(events);
  }, [events]);

  const CustomToolbar = (toolbar) => {
    const date = moment(toolbar.date);
    const goToBack = () => {
      setDefaultDate((prevDate) => new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1));
    };

    const goToNext = () => {
      setDefaultDate((prevDate) => new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1));
    };

    const goToCurrent = () => {
      const now = new Date();
      toolbar.date.setDate(moment(now).format('DD'));
      toolbar.date.setMonth(now.getMonth());
      toolbar.date.setYear(now.getFullYear());
      toolbar.onhistory('current');
    };

    const label = () => {
      return (
        <span>
          <b>{calenderView === Views.MONTH ? date.format('MMM YYYY') : date.format('Do MMM')}</b>
        </span>
      );
    };

    return (
      <div>
        <div className="calendar-header-buttons">
          <div style={styles.teacherAvailabilityCalenderButton}>
            <h2>{moment(defaultDate).format('MMMM YYYY').toString()}</h2>
            <div className="calendar-navigations">
              <img
                src={RightIcon}
                alt={'left'}
                style={{
                  ...styles.teacherAvailabilityCalenderButtonImage,
                  transform: 'scale(-1)',
                }}
                onClick={goToBack}
              />

              <img
                src={RightIcon}
                alt={'Right'}
                style={styles.teacherAvailabilityCalenderButtonImage}
                onClick={goToNext}
              />
            </div>
          </div>
          <FormControl variant="standard" style={styles.teacherAvailabilityCalenderButton}>
            <Select
              className={classes.teacherAvailabilityCalenderButtonImage}
              value={calenderView}
              style={{
                ...styles.teacherAvailabilityCalenderButtonImage,
                width: '120px',
                height: '40px',
                border: '1px solid #d3d3d3',
                borderRadius: '24px',
                padding: '10px',
              }}
              onChange={(e) => setCalenderView(e.target.value.toLowerCase())}
              IconComponent={ArrowDropDownIcon}
              disableUnderline
              sx={{
                boxShadow: 'none',
                '.MuiSelect-select': { paddingRight: '36px' },
              }}
            >
              {CalenderViewButton.map((view) => (
                <MenuItem key={view} value={view}>
                  {view.toUpperCase()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    );
  };

  const customStyle = (event) => {
    return {
      style: {
        background: '#e6f2f0',
        borderLeft: '3px solid #26796b',
        color: 'black',
        borderRadius: '5px',
        height: calenderView === Views.MONTH ? '100px' : '0px',
        fontSize: calenderView === Views.MONTH ? '15px' : '15px',
      },
    };
  };

  const goToDay = (e) => {
    if (calenderView === Views.DAY) {
      setEventDetails({ event: e, showModal: true });
      return;
    }
    setDefaultDate(e.start);
    setCalenderView(Views.DAY);
  };

  function CustomEvent({ event }) {
    return (
      <div>
        <div onClick={() => setEventDetails({ event, showModal: true })}>
          {calenderView === Views.MONTH && (
            <>
              <span style={{ color: 'grey', fontSize: '13px' }}>
                {`${moment(event.start).format('hh:mm A')} - ${moment(event.end).format('hh:mm A')}`}
              </span>
              <div style={{ marginBlock: '10px' }} />
              <span>{event.title}</span>
            </>
          )}
          {calenderView !== Views.MONTH && <span>{event.title}</span>}
        </div>
      </div>
    );
  }

  return (
    // <div className="calendar-div">
    <div style={{ width: '100%' }}>
      {/* Split layout for Calendar and other content */}
      <CustomToolbar />
      <div
        style={{
          display: width > 1000 ? 'flex' : 'block',
          border: '0.5px solid grey',
          borderRadius: '10px',
          background: '#fff',
        }}
      >
        <div style={{ width: width > 1000 ? '20%' : '100%', marginTop: '20px' }}>
          <Button
            text="New Task"
            onClick={handleAddEvent}
            fullWidth
            startIcon={<AddIcon />}
            style={{ width: '95%', marginLeft: '7px' }}
          />

          <div style={{ marginTop: '20px' }}>
            <SmallCalendar
              onClickDay={(e) => {
                setDefaultDate(e);
                setCalenderView(Views.DAY);
              }}
              onClickMonth={(e) => {
                setDefaultDate(e);
                setCalenderView(Views.MONTH);
              }}
              next2Label={null}
              prev2Label={null}
              value={defaultDate}
              className="small-calendar"
            />
          </div>
        </div>
        <div style={{ width: width > 1000 ? '80%' : '100%', height: '80vh' }}>
          <Calendar
            date={defaultDate}
            defaultDate={defaultDate}
            defaultView={Views.MONTH}
            events={myEvents}
            view={calenderView}
            localizer={localizer}
            eventPropGetter={customStyle}
            components={{ event: CustomEvent }}
            // onSelectEvent={goToDay}
            selectable={false}
            step={30}
            timeslots={1}
            toolbar={false}
          />
        </div>
      </div>

      <Dialog className={classes.modal} open={eventDetails.showModal}>
        <EventDetails
          closeModal={() => setEventDetails({ event: null, showModal: false })}
          event={eventDetails.event}
        />
      </Dialog>
    </div>
  );
}

export default Index;
